/**
 * SaveFooter — the end of the form: why Save is blocked when no
 * project is picked, the Save button, the last save error, and Delete for a
 * re-opened entry.
 */


export interface SaveFooterProps {
  project_ref: string | null;
  canRoute: boolean;
  saving: boolean;
  routingReviewPending: boolean;
  activeRoutingDetection: boolean;
  explicitRoutingChoice: boolean;
  handleSave: () => void;
  saveError: string | null;
  onDeleteEntry?: () => void;
}

export function SaveFooter({
  project_ref,
  canRoute,
  saving,
  routingReviewPending,
  activeRoutingDetection,
  explicitRoutingChoice,
  handleSave,
  saveError,
  onDeleteEntry,
}: SaveFooterProps) {
  return (
    <>
      {project_ref === null && (
        <p data-testid="save-screen-no-project-reason">
          Pick a project before saving — every capture is scoped to a project.
        </p>
      )}

      <button
        type="button"
        data-testid="save-screen-save"
        disabled={!canRoute || saving}
        aria-describedby={routingReviewPending
          ? "save-screen-routing-rechecking"
          : activeRoutingDetection && !explicitRoutingChoice ? "save-screen-routing-heading" : undefined}
        onClick={handleSave}
      >
        {saving ? "Saving…" : onDeleteEntry ? "Save changes" : "Save to project"}
      </button>
      {saveError && (
        <p data-testid="save-screen-save-error" role="alert">{saveError}</p>
      )}

      {/* Re-opened entries only. Deliberately last and visually quiet: it is the
          one destructive control on the screen, and a super scrolling to Save
          should not meet it first. */}
      {onDeleteEntry && (
        <button
          type="button"
          data-testid="save-screen-delete-entry"
          onClick={onDeleteEntry}
          style="background:none;border:1px solid var(--mark-border-default);color:var(--mark-status-critical)"
        >
          Delete this entry
        </button>
      )}
    </>
  );
}
